import API from "Api";
import {
  GET_REPEATORDER_TO_ORDERPAD_ENDPOINT,
  GET_CREATE_ORDERPAD_ENDPOINT,
  GET_CREATE_TODAY_ORDERPAD_ENDPOINT,
} from "./endpoints";

//Orderpad list
export const repeatorderToOrderpadAPI = (payload) => {
  return API.post(GET_REPEATORDER_TO_ORDERPAD_ENDPOINT, payload);
};

// Create OrderPad
export const createOrderPadAPI = (payload) => {
  return API.post(GET_CREATE_ORDERPAD_ENDPOINT, payload);
};

// Create  Today OrderPad
export const createTodayOrderPadAPI = (payload) => {
  return API.post(GET_CREATE_TODAY_ORDERPAD_ENDPOINT, payload);
};
